import { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { type UsersTotals, type ActivityType } from '../models/engagement-users'
import { GetUsersTotalsQuery } from '../../data/queries/get-users-totals.query'
import { type UsersTotalsEntity } from '../../data/entities/users.entity'

export interface GetUsersTotalsParams {
  fromDate: string
  toDate: string
  activityType: ActivityType
  organization: string
}

export class GetUsersTotalsInteractor {
  constructor(private readonly repository: GetInteractor<UsersTotalsEntity>) {}

  public async execute(params: GetUsersTotalsParams): Promise<UsersTotals> {
    const response = await this.repository.execute(
      new GetUsersTotalsQuery(params.fromDate, params.toDate, params.activityType, params.organization)
    )

    return {
      activity_type: response.activity_type as ActivityType,
      users: response.users
    }
  }
}
